import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function employeeProfileReducer(state = initialState.employeeProfile, action) {
  switch (action.type) {
    case types.GET_EMPLOYEE_PROFILE_SUCCESS:
      return action.employeeProfile;
    case types.CLEAR_EMPLOYEE_PROFILE:
      return initialState.employeeProfile;
    default:
      return state;
  }
}
